import LoyaltySelectedAvatar from "components/molecules/LoyaltySelectedAvatar";
import LoyaltyAvatarList from "components/molecules/LoyaltyAvatarList";
import { ILoyaltyAvatarListItem } from "types/Loyalty";
import "./styles.sass";

type LoyaltyAvatarMobileProps = {
  activeAvatarId: string | null;
  activeAvatar: string | null;
  mascots: ILoyaltyAvatarListItem[];
  onHandleSelect: (mascotId: string) => void;
};

const LoyaltyAvatarMobile = (props: LoyaltyAvatarMobileProps) => {
  const { activeAvatarId, activeAvatar, mascots, onHandleSelect } = props;

  return (
    <div className="LoyaltyAvatarMobile">
      <div>
        <LoyaltySelectedAvatar bg="white" avatar={activeAvatar} />
      </div>
      <div>
        <LoyaltyAvatarList
          list={mascots}
          selected={activeAvatarId}
          handleSelect={onHandleSelect}
        />
      </div>
    </div>
  );
};

export default LoyaltyAvatarMobile;
